import { defineProperty, getOwnPropertyDescriptor, keys } from '../shortcut'

export function hoistStatic(target?: any, source?: any): void {
  if (
    (typeof target !== 'function' &&
      (typeof target !== 'object' || target === null)) ||
    (typeof source !== 'function' &&
      (typeof source !== 'object' || source === null))
  ) {
    return
  }

  for (const key of keys(source)) {
    if (
      key === '$$typeof' ||
      key === 'render' ||
      key === 'compare' ||
      key === 'type' ||
      key === 'displayName' ||
      key.startsWith('__')
    ) {
      continue
    }

    const descriptor = getOwnPropertyDescriptor(source, key)
    if (descriptor !== undefined) defineProperty(target, key, descriptor)
  }
}
